import type { DailyBriefingResponse } from '@/shared/types'
import { API_BASE, createHeaders } from './base'

// The /api/layout endpoint uses a tile-based layout shape (distinct from the
// shared Layout type which represents a different schema). This interface mirrors
// the actual API contract.
export interface TileLayoutResponse {
  tiles: Array<{
    id: string
    component: string
    colSpan: 1 | 2 | 3 | 4 | 5 | 6
    rowSpan: 1 | 2 | 3
    visible?: boolean
  }>
}

export async function fetchLayout(): Promise<TileLayoutResponse> {
  const response = await fetch(`${API_BASE}/layout`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch layout')
  return response.json()
}

export async function updateLayout(layout: TileLayoutResponse): Promise<TileLayoutResponse> {
  const response = await fetch(`${API_BASE}/layout`, {
    method: 'PUT',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(layout),
  })
  if (!response.ok) throw new Error('Failed to update layout')
  return response.json()
}

export async function getDailyBriefing(): Promise<DailyBriefingResponse> {
  const response = await fetch(`${API_BASE}/dashboard/daily-briefing`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch daily briefing')
  return response.json()
}
